import { useCallback, useRef } from 'react';
import { useWalkmeSdkService } from '../../../infrastructure/WalkmeSdkProvider/useWalkmeSdkService';

export const useSetupLoadEnd = () => {
    const { walkmeSdkService } = useWalkmeSdkService();

    const intiRef = useRef(false);

    const setupLoadEnd = useCallback(() => {
        if (intiRef.current) {
            return;
        }
        intiRef.current = true;
        window.sendLoadEndEvent = function () {
          walkmeSdkService.sendLoadEndEvent();
          delete window.sendLoadEndEvent
        }
    }, [walkmeSdkService]);

    return setupLoadEnd;
};
